// REACT
import React from "react";

// REACT BOOTSTRAP
import { Col, Nav, Row, Tab } from "react-bootstrap";

// REDUX
import { useSelector, useDispatch } from "react-redux";

// REACT ROUTER
import { useParams } from "react-router-dom";

// INTERNATIONALIZATION
import { FormattedMessage } from "react-intl";

// STORE ACTIONS
import { editApplication } from "store/actions";

// COMPONENTS
import Form from "components/Form";
import Input from "components/Form/input";
import ModalWrapperBtn from "components/shared/modal-wrapper-btn";
import SaveChangesButton from "components/Form/save-changes-button";
import InputsGroup from "components/Form/inputs-group";
import FormWrapper from "components/Form/form-wrapper";

// DATA
import { appEvents, storeEvents } from "data";

const ApplicationAlerts = () => {
    const dispatch = useDispatch();
    const { applicationId } = useParams();

    const { singleApplication } = useSelector((state) => state.applications);
    let FourthFormValues = {
        webhookUrl: singleApplication?.webhookUrl,
        webhookSecretKey: singleApplication?.webhookSecretKey,
        webhookSecurityStrategy: singleApplication?.webhookSecurityStrategy,
        events: singleApplication?.events || [
            "productsCreate",
            "productsDataUpdate",
        ],
        customHeaders: singleApplication?.customHeaders || [
            { special: "asd", value: "asd" },
        ],
    };

    const onSubmitWebhook = (data) => {
        dispatch(
            editApplication({
                endpointName: "webhook",
                id: applicationId,
                data,
            })
        );
    };
    return (
        <FormWrapper>
            <Form onSubmit={onSubmitWebhook} defaultValues={FourthFormValues}>
                <Col xs="12" md="3">
                    <h5 className="side-title">
                        <FormattedMessage id="alerts" />
                    </h5>
                </Col>
                <Col xs="12" md="9">
                    <Row>
                        <Col xs="12">
                            <Input
                                name="webhookUrl"
                                type="url"
                                lg="12"
                                rules={{ required: false }}
                                autoCapitalize="off"
                                autoComplete="off"
                                autoCorrect="off"
                                spellCheck="false"
                            />
                        </Col>
                        <Col xs="12">
                            <label className="side-title">
                                <FormattedMessage id="webhookSecurityStrategy" />
                            </label>
                            <Row>
                                <Input
                                    name="webhookSecurityStrategy"
                                    type="radio"
                                    value="signature"
                                    langId={"signature"}
                                    xs="4"
                                    lg="2"
                                    breakpoints={{ md: 3 }}
                                    rules={{ required: false }}
                                />
                                <Input
                                    name="webhookSecurityStrategy"
                                    type="radio"
                                    value="token"
                                    langId={"token"}
                                    xs="4"
                                    lg="2"
                                    breakpoints={{ md: 3 }}
                                    rules={{ required: false }}
                                />
                                <Input
                                    name="webhookSecurityStrategy"
                                    type="radio"
                                    value="none"
                                    langId={"none"}
                                    xs="4"
                                    lg="2"
                                    breakpoints={{ md: 3 }}
                                    rules={{ required: false }}
                                />
                            </Row>
                        </Col>
                        <Col xs="12">
                            <Input
                                name="webhookSecretKey"
                                type="password"
                                toggleView="true"
                                lg="12"
                                rules={{ required: false }}
                                autoCapitalize="off"
                                autoComplete="off"
                                autoCorrect="off"
                                spellCheck="false"
                            />
                        </Col>
                        <Col xs="12">
                            <div className="modal-item">
                                <label>
                                    <FormattedMessage id="applicationEvents" />
                                </label>
                                <Col xs="4" lg="2" md="3">
                                    <ModalWrapperBtn
                                        title={
                                            <FormattedMessage id="applicationEvents" />
                                        }
                                        btnText={
                                            <FormattedMessage id="showEvents" />
                                        }
                                        handleSave={() => {}}
                                    >
                                        {appEvents?.map((e, index) => (
                                            <Row key={index}>
                                                <a href={e?.website}>
                                                    {e.label}
                                                </a>
                                            </Row>
                                        ))}
                                    </ModalWrapperBtn>
                                </Col>
                            </div>
                        </Col>
                        <Col xs="12">
                            <div className="modal-item">
                                <label>
                                    <FormattedMessage id="storeEvents" />
                                </label>
                                <Col xs="4" lg="2" md="3">
                                    <ModalWrapperBtn
                                        title={
                                            <FormattedMessage id="storeEvents" />
                                        }
                                        btnText={
                                            <FormattedMessage id="addEvents" />
                                        }
                                        handleSave={() => {}}
                                    >
                                        <Tab.Container
                                            id="left-tabs-example"
                                            defaultActiveKey={
                                                storeEvents?.[0]?.name
                                            }
                                        >
                                            <Row>
                                                <Col xs="4">
                                                    <Nav
                                                        variant="pills"
                                                        className="flex-column"
                                                    >
                                                        {storeEvents?.map(
                                                            (e, k) => (
                                                                <Nav.Item
                                                                    key={k}
                                                                >
                                                                    <Nav.Link
                                                                        eventKey={
                                                                            e?.name
                                                                        }
                                                                    >
                                                                        <FormattedMessage
                                                                            id={
                                                                                e?.name
                                                                            }
                                                                        />
                                                                    </Nav.Link>
                                                                </Nav.Item>
                                                            )
                                                        )}
                                                    </Nav>
                                                </Col>
                                                <Col xs="8">
                                                    <Tab.Content>
                                                        {storeEvents?.map(
                                                            (e, k) =>
                                                                e?.options?.map(
                                                                    (
                                                                        op,
                                                                        k1
                                                                    ) => (
                                                                        <Tab.Pane
                                                                            eventKey={
                                                                                e?.name
                                                                            }
                                                                            key={`${k}-${k1}`}
                                                                        >
                                                                            <Input
                                                                                type="checkbox"
                                                                                name="events[]"
                                                                                value={
                                                                                    op
                                                                                }
                                                                                langId={
                                                                                    false
                                                                                }
                                                                                lg="12"
                                                                            >
                                                                                <small className="ps-2">
                                                                                    {
                                                                                        op
                                                                                    }
                                                                                </small>
                                                                            </Input>
                                                                        </Tab.Pane>
                                                                    )
                                                                )
                                                        )}
                                                    </Tab.Content>
                                                </Col>
                                            </Row>
                                        </Tab.Container>
                                    </ModalWrapperBtn>
                                </Col>
                            </div>
                        </Col>
                        <Col xs="12" className="p-0">
                            <Row className="custom-headers">
                                <Col xs="12" md="4">
                                    <label className="side-title">
                                        <FormattedMessage id="customHeaders" />
                                    </label>
                                </Col>
                                <Col xs="12" md="8">
                                    <InputsGroup
                                        title={false}
                                        name="customHeaders"
                                        inputs={[
                                            {
                                                name: "special",
                                                type: "text",
                                            },
                                            {
                                                name: "value",
                                                type: "text",
                                            },
                                        ]}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <SaveChangesButton />
            </Form>
        </FormWrapper>
    );
};

export default ApplicationAlerts;
